import env from '@/api/env';
import axios from 'axios';
import store from '@/store/index';
import auth from '@/api/auth'

export default {


	async login()
	{
		const { jwt } = auth;

		if(!jwt) throw new Error('Auth JWT required for Fusion login');
		
		const url = `${env.wellness()}/auth/login`;

		const { data } = await this.get(url, {
			headers: {
				Authorization: `Bearer ${auth.jwt}`,
			}
		});

		const { token } = data;
		this.jwt = token;

		return token;

	},


	async wellnessLogin()
	{
		const url = `${env.wellness()}/thryve/login`;

		const { data } = await this.get(url, {
			headers: {
				Authorization: `Bearer ${this.jwt}`,
			}
		});

		return data;

	},

	async wellnessUploadUserValue(token, value)
	{
		const url = `${env.wellness()}/thryve/user/value`;

		const { data } = await this.post(url, value, {
			headers: {
				'Content-Type': 'application/json',
				authenticationToken: token,
				Authorization: `Bearer ${this.jwt}`,
			}
		});

		return data;

	},

	async wellnessUploadUserDailyValue(token, value)
	{
		const url = `${env.wellness()}/thryve/user/value/daily`;

		const { data } = await this.post(url, value, {
			headers: {
				'Content-Type': 'application/json',
				authenticationToken: token,
				Authorization: `Bearer ${this.jwt}`,
			}
		});

		return data;

	},

	async wellnessUserValue(token, startTimestamp, endTimestamp)
	{
		const url = `${env.wellness()}/thryve/user/value`;

		const { data } = await this.get(url, {
			params: { startTimestamp, endTimestamp }, 
			headers: {
				'Content-Type': 'application/json',
				authenticationToken: token,
				Authorization: `Bearer ${this.jwt}`,
			}
		});

		return data;

	},

	async wellnessUserDailyValue(token, startDay, endDay)
	{
		const url = `${env.wellness()}/thryve/user/value/daily`;

		const { data } = await this.get(url, {
			params: { startDay, endDay }, 
			headers: {
				'Content-Type': 'application/json',
				authenticationToken: token,
				Authorization: `Bearer ${this.jwt}`,
			}
		});

		return data;

	},
	
	async post(url, body, options)
	{
		let response;

		store.dispatch('navigation/loading', { [url]: true });
		

		try {
			response = await axios.post(url, body, options);
		} catch(e) {
			store.dispatch('navigation/loading', { [url]: false });
			throw e;
		}

		store.dispatch('navigation/loading', { [url]: false });
		return response;

	},

	async get(url, options)
	{
		let response;

		store.dispatch('navigation/loading', { [url]: true });
		

		try {
			response = await axios.get(url, options);
		} catch(e) {
			store.dispatch('navigation/loading', { [url]: false });
			throw e;
		}

		store.dispatch('navigation/loading', { [url]: false });
		return response;

	}
}
